<template>
  <div>
    <v-hover v-slot="{ hover }">
      <div :class="{ 'hoveredBackground': hover }" class="cursorPointer" @click="editBasics">
        <v-banner class="banner-without-padding py-1" style="top:50px; z-index:1" sticky color="primary" single-line>
          <v-layout wrap>
            <v-flex xs12 class="primary white--text" text-center>
              <h3>
                <span>{{ $t('a') }}</span>
                <v-icon small class="ml-2" :class="{ 'white--text': hover, 'primary--text': !hover }">mdi-pen</v-icon>
              </h3>
            </v-flex>
          </v-layout>
        </v-banner>
        <v-divider/>
        <v-layout wrap>
          <v-flex xs12>
            <v-layout wrap>
              <v-flex xs3 class="leftCell" pl-1>{{ $t('b') }}</v-flex>
              <v-flex xs9 pl-2>{{ dossier.profile.trigram }}</v-flex>
            </v-layout>
            <v-divider/>
          </v-flex>
          <v-flex xs12>
            <v-layout wrap>
              <v-flex xs3 class="leftCell" pl-1>{{ $t('c') }}</v-flex>
              <v-flex xs9 pl-2>{{ dossier.profile.xpYears }}</v-flex>
            </v-layout>
            <v-divider/>
          </v-flex>
          <v-flex xs12>
            <v-layout wrap>
              <v-flex xs3 class="leftCell" pl-1>{{ $t('d') }}</v-flex>
              <v-flex xs9 pl-2>{{ dossier.profile.firstName }}</v-flex>
            </v-layout>
            <v-divider/>
          </v-flex>
          <v-flex xs12>
            <v-layout wrap>
              <v-flex xs3 class="leftCell" pl-1>{{ $t('e') }}</v-flex>
              <v-flex xs9 pl-2>{{ dossier.profile.lastName }}</v-flex>
            </v-layout>
            <v-divider/>
          </v-flex>
          <v-flex xs12>
            <v-layout wrap>
              <v-flex xs3 class="leftCell" pl-1>{{ $t('f') }}</v-flex>
              <v-flex xs9 pl-2>{{ dossier.profile.topDegree }}</v-flex>
            </v-layout>
            <v-divider/>
          </v-flex>
          <v-flex xs12>
            <v-layout wrap>
              <v-flex xs3 class="leftCell" pl-1>{{ $t('g') }}</v-flex>
              <v-flex xs9 pl-2>{{ dossier.profile.birthYear }}</v-flex>
            </v-layout>
            <v-divider/>
          </v-flex>
          <v-flex xs12>
            <v-layout wrap>
              <v-flex xs3 class="leftCell" pl-1>{{ $t('h') }}</v-flex>
              <v-flex xs9 pl-2>{{ dossier.profile.title }}</v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </div>
    </v-hover>
  </div>
</template>

<script>

export default {
  props: {
    dossier: Object
  },
  data: () => ({
  }),
  methods: {
    editBasics() {
      this.$emit('setFieldPath', { fieldPath: ['basics'], savedScrollEltId: `view-basics` })
    }
  }
}
</script>


<i18n>
{
  "fr": {
    "a": "Présentation",
    "b": "Trigramme",
    "c": "Années d'expérience",
    "d": "Prénom",
    "e": "Nom de famille",
    "f": "Niveau de diplôme",
    "g": "Année de naissance",
    "h": "Titre du candidat"
  },
  "en": {
    "a": "Presentation",
    "b": "Trigram",
    "c": "Years of experience",
    "d": "First name",
    "e": "Last name",
    "f": "Top degree",
    "g": "Year of birth",
    "h": "Title of the candidate"
  }
}
</i18n>